import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { numerals } from 'util/dom/mq';

/**
 * Please don't touch this file unless you know what you are doing!!!
 * Jaws is really inconsistent in dispatching alert messages and here we need to work with timers in order
 * to let it dispatch properly the user messages
 */

class AccessibleAlert extends PureComponent {
    static propTypes = {
        messageDesktop: PropTypes.string.isRequired,
        messageMobile: PropTypes.string.isRequired,
        mq: PropTypes.object.isRequired,
    };

    state = {
        canBeRendered: false,
        currentMq: null,
    };

    componentDidUpdate({ mq }) {
        if (mq.width !== this.state.currentMq) {
            this.setState({ currentMq: mq.width });
        }
    }

    render() {
        const { currentMq } = this.state;
        const { messageMobile, messageDesktop } = this.props;

        if (currentMq > numerals.SM) {
            return <span
                tabIndex={0}
                className="accessible-alert">{messageDesktop}</span>;
        }

        //mobile
        return <span
            tabIndex={0}
            className="accessible-alert">{messageMobile}</span>;
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        mq: 'viewport.mq',
    }),
)(AccessibleAlert);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/accessibile-alert/index.js